const ViewTypeEnum = Object.freeze({
  TABLE: 'table',
  TILE: 'tile'
});

export { ViewTypeEnum };
